import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useLocation } from "react-router-dom";
// @material-ui/core components
import Box from "@material-ui/core/Box";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
//import custom components
import componentStylesGeneric from "assets/theme/views/admin/generic.js";
import LocationHeader from "components/Headers/LocationHeader";
import PageTitleHeader from "components/Headers/PageTitleHeader.js";
import useQueryParams from "hooks/useQueryParams";
import { useIntl } from "react-intl";
import { labels, titles } from "resources/resources";
import ResultSection from "./Sections/StructuringProjects_ResultSection";

const useStylesGeneric = makeStyles(componentStylesGeneric);

const PAGE_INDEX_QUERY_PARAM_KEY = "sp_pageIndex";

function StructuringProjects() {
  const classes = useStylesGeneric();
  const intl = useIntl();
  const location = useLocation();
  const { getQueryParam, getQueryParams, setQueryParams } = useQueryParams();

  const [pageIndex, setPageIndex] = useState(() => {
    const fromUrl = Number(getQueryParam(PAGE_INDEX_QUERY_PARAM_KEY) ?? 1);
    return fromUrl > 0 ? fromUrl : 1;
  });

  // Sync pagination to URL (pageIndex only when > 1)
  useEffect(() => {
    const currentParams = getQueryParams();
    if (Number(pageIndex) > 1) {
      currentParams[PAGE_INDEX_QUERY_PARAM_KEY] = Number(pageIndex);
    } else {
      delete currentParams[PAGE_INDEX_QUERY_PARAM_KEY];
    }
    setQueryParams(currentParams, true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageIndex]);

  // Restore state from URL on back/forward navigation
  useEffect(() => {
    const fromUrl = Number(getQueryParam(PAGE_INDEX_QUERY_PARAM_KEY) ?? 1);
    const nextPageIndex = fromUrl > 0 ? fromUrl : 1;
    setPageIndex((prev) => (prev === nextPageIndex ? prev : nextPageIndex));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search]);

  const handleChangePage = (event, value) => {
    setPageIndex(value);
  };

  return (
    <Container
      maxWidth={false}
      component={Box}
      classes={{ root: classes.containerRoot }}
    >
      <LocationHeader
        section={intl.formatMessage(titles.Title_StructuringProjects)}
      />
      <PageTitleHeader
        titleId="structuring-projects"
        title={intl.formatMessage(titles.Title_StructuringProjects)}
      />
      <Box component={Grid} container justifyContent="center">
        <Grid item xs={12} md={12}>
          <Box className={classes.pageLabels}>
            {intl.formatMessage(
              labels.Label_HomePage_StructuringProjects_Description
            )}
          </Box>
        </Grid>
        <Grid item xs={12} md={12}>
          <ResultSection pageIndex={pageIndex} handleChangePage={handleChangePage} />
        </Grid>
      </Box>
    </Container>
  );
}

const mapStateToProps = (state) => ({ ...state });

export default connect(mapStateToProps)(StructuringProjects);
